/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import type React from "react";
import { Form } from "@fas/ui-core";
import { withForm } from "@fas/ui-framework";
import { Typography, Button } from "@mui/material";
import { Helmet } from "react-helmet";
import { RESTORE_PASSWORD_FORM } from "@fas/cpa-state-manager/redux/constants";
import { EmailOutlined } from "@mui/icons-material";
import environment from "environment";
import TextField from "../TextFieldForm";
import AuthFormGrid from "../AuthFormGrid";
import schema from "./validation";
import { getValidation } from "../../utils";

const RestorePasswordForm = withForm(Form);
const typographySx = {
  mb: 4,
  textAlign: "center",
  minWidth: {
    sm: "max-content",
  },
};
const inputSx = {};
const btnSx = {
  mb: 1,
};
type Props = {
  isLoading: boolean;
  onKeyPress: (arg0: React.KeyboardEvent<any>) => unknown;
  onSave: () => unknown;
};

const RestorePassword: FC<Props> = ({ isLoading, onKeyPress, onSave }) => (
  <>
    <Helmet>
      <title>
        Restore password
      </title>
    </Helmet>
    <RestorePasswordForm
      id={RESTORE_PASSWORD_FORM}
      validate={getValidation(schema)}
      onSave={onSave}
    >
      <AuthFormGrid>
        <Typography variant="gradientH1" sx={typographySx}>
          Restore Password
        </Typography>
        <TextField
          name="email"
          label="Your Email"
          placeholder="Input your email"
          autoFocus
          StartIcon={<EmailOutlined />}
          onKeyPress={onKeyPress}
          sx={inputSx}
          inputProps={{
            inputMode: "email",
          }}
        />
        <Button
          sx={btnSx}
          disabled={isLoading}
          data-testid="restore-password-save"
          fullWidth
          variant="gradient"
          type="submit"
        >
          Restore Password
        </Button>
        <Button
          sx={btnSx}
          data-testid="redirect-login"
          fullWidth
          variant="transparent"
          component="a"
          href={environment.links.login}
        >
          Back to Log In
        </Button>
      </AuthFormGrid>
    </RestorePasswordForm>
  </>
);

export default RestorePassword;
